import * as Sentry from '@sentry/nextjs';

export interface IUser {
  mobileNumber: string;
}

export const configSentry = (user: IUser) => {
  Sentry.setExtra('ua', window.navigator.userAgent);
  Sentry.setTag('app', 'WitroShop');
  Sentry.setUser({
    id: user.mobileNumber,
  });
};
